<template>
  <div :class="$style.root" @click="toggle">
    <img class="w-100 h-auto" :src="src" alt="">

    <transition name="fade">
      <div v-if="isFullscreen"
           :class="$style.fullscreen"
           class="position-fixed vw-100 vh-100 d-flex align-items-center">
        <button id="mk-image" :class="$style.close" class="btn-reset" @click="toggle">
          <img src="../../assets/fechar-icon.svg" alt="">
        </button>

        <img class="w-100 h-auto" :src="src" alt="">
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'Media',
    props: {
      src: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        isFullscreen: false
      };
    },
    methods: {
      toggle(e) {
        e.stopPropagation();
        this.isFullscreen = !this.isFullscreen;
      }
    }
  }
</script>

<style lang="scss" module>
  .root {
    cursor: pointer;
  }

  .close {
    z-index: 1002;
    cursor: pointer;
    position: absolute;
    top: $spacer-4;
    right: $spacer-4;
  }

  .fullscreen {
    z-index: 1001;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }
</style>
